(function () {
  const WHATSAPP = "393318382683"; // <-- cambia qui se vuoi
  function productName() {
    return (document.querySelector("h1")?.textContent || "Prodotto").trim();
  }

  function inject() {
    const box = document.querySelector("#ec-box-calc");
    if (!box) return;

    if (box.querySelector(".vetrina-ask-info")) return;

    const msg = `Ciao, vorrei info su: ${productName()} - ${location.href}`;
    const a = document.createElement("a");
    a.className = "button vetrina-ask-info";
    a.href = `https://wa.me/${WHATSAPP}?text=${encodeURIComponent(msg)}`;
    a.target = "_blank";
    a.rel = "noopener";
    a.textContent = "Richiedi info";

    // lo mettiamo dove stava il form
    box.appendChild(a);
  }

  document.addEventListener("DOMContentLoaded", inject);
  setTimeout(inject, 1000); // nel caso il widget carichi dopo
})();
